import React from "react";
import PropTypes from "prop-types";
import { Input } from "reactstrap";

import InputGroup from "./InputGroup";
import InvalidMessage from "./InvalidMessage";

export default function TextInput(props) {
  const {
    userInput,
    onChange,
    stateKey,
    labelText,
    invalidMessage,
    placeholder
  } = props;
  return (
    <InputGroup
      labelText={labelText}
      name={stateKey}
      isValid={userInput.isValid}
    >
      <Input
        valid={userInput.isValid}
        placeholder={placeholder}
        type="text"
        value={userInput.val}
        onChange={onChange.bind(null, stateKey)}
      />
      <InvalidMessage isValid={userInput.isValid} message={invalidMessage} />
    </InputGroup>
  );
}

TextInput.displayName = "TextInput";

TextInput.propTypes = {
  userInput: PropTypes.shape({
    isValid: PropTypes.bool,
    value: PropTypes.string
  }).isRequired,
  // stateKey maps to the key where the value is stored in state, and is bound to
  // the onChange handler
  stateKey: PropTypes.string.isRequired,
  labelText: PropTypes.string.isRequired,
  invalidMessage: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

TextInput.defaultProps = {
  invalidMessage: "Invalid input"
};



// WEBPACK FOOTER //
// ./src/Shared/Forms/TextInput.js